import styled from "@emotion/styled";

const BlockContainer = styled.div`
  background: var(--csa-bg-secondary);
  overflow: scroll;
  padding: 1.5rem;
`;

export default BlockContainer;
